import { type AdyenFlagObject } from '@quickmd-llc/design-system'

export type Flags = {
  id_verification_show_tag_admin: boolean
  adyen: AdyenFlagObject
  id_verification_show_tag_provider: boolean
  product_order_types: string[]
  dts_moud_pilot: string[]
  merge_duplicate_accounts: {
    isActive: boolean
  }
  pdmp_pilot: string[]
  pdmp_integrated_states: string[]
  admin_google_sso: boolean
  pharmacy_search_daw: boolean
  /**
   * Kill switch for the Kratom / 7-OH support-plan badge (QMD-4144). Admin's own
   * key rather than provider's `program_visit_badge_provider`, matching the
   * `id_verification_show_tag_admin` / `_provider` precedent: the two audiences
   * are turned on separately.
   */
  program_visit_badge_admin: boolean
}

export const defaultFlags: Flags = {
  id_verification_show_tag_admin: false,
  adyen: { enabled: false, only_enabled_for_users_created_after: null },
  id_verification_show_tag_provider: false,
  product_order_types: [],
  dts_moud_pilot: [],
  merge_duplicate_accounts: { isActive: false },
  pdmp_pilot: [],
  pdmp_integrated_states: [],
  admin_google_sso: true,
  pharmacy_search_daw: false,
  program_visit_badge_admin: false,
}
